module.exports = __webpack_public_path__ + "static/media/phone.5f78d8fd.svg";